import * as React from "react";

interface CategoryCardProps {
  id: string;
  name: string;
  icon?: string;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

const CategoryCard: React.FC<CategoryCardProps> = ({
  id,
  name,
  icon,
  isSelected,
  onSelect,
}) => {
  return (
    <div
      onClick={() => onSelect(id)}
      className={`w-[220px] cursor-pointer border rounded-lg p-4 flex flex-col items-left justify-center text-center transition-colors duration-300 
        ${isSelected ? "bg-gray-100 border-primary" : "bg-white border-gray-200"}`}
    >
      {icon ? (
        <div className="w-10 h-10">
          <img src={icon} alt={name} className="w-auto h-8 mb-4" />
        </div>
      ) : (
        <div className="w-12 h-12 mb-4 bg-gray-300" />
      )}
      <span className="font-ubuntu text-sm text-left">{name}</span>
    </div>
  );
};

export default CategoryCard;
